export default openAria => {
    if ($('.open-aria').length < 1) {
        return false;
    }

    let $openAria = $('.open-aria');

    $openAria.on('click', event => {
        let $button = $(event.currentTarget);
        let $aria = $(`div[data-aria=${$button.data('target')}]`);

        $aria.slideToggle();
        $button.toggleClass('down');

        if ($button.attr('aria-expanded') === 'false') {
            $button.attr('aria-expanded', 'true');
        } else {
            $button.attr('aria-expanded', 'false');
        }

        return false;
    });
};
